import { Box, ClickAwayListener, Tooltip, Typography, useTheme } from "@mui/material";
import { ReactNode, useState } from "react";

import { ReactComponent as LeftBunt } from '../images/Heading_EvenBuntLeft.svg';
import { ReactComponent as RightBunt }  from '../images/Heading_EvenBuntRight.svg';

interface HeadingBarProps {
    children?: ReactNode
    extendBunts?: boolean;
    center?: boolean;
}

type TextAlign = 'left' | 'center' | 'right' | 'justify' | 'start' | 'end';

export const HeadingBarItem = (props: { children?: ReactNode, tooltip?: string, textAlign?: TextAlign, lineHeight?: any}) => {
    const [ open, setOpen ] = useState(false);
    const [ hover, setHover ] = useState(false);

    // return <Tooltip title={props.tooltip} open={open} onClick={() => setOpen(true)} >
    //     <>{props.children}</>
    // </Tooltip>;
    return <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Tooltip title={props.tooltip} open={open || hover} onClick={() => setOpen(true)} onMouseOver={() => setOpen(true)} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <div style={{textAlign: props.textAlign, height: "100%", lineHeight: props.lineHeight }}>{props.children}</div>
        </Tooltip>
    </ClickAwayListener>
}

const HeadingBar = (props: HeadingBarProps) => {
    const { children, extendBunts, center } = props;
    const theme = useTheme();

    return <Box display="flex" height={"24px"} marginX={extendBunts ? "-6px" : undefined}>
        <LeftBunt fill={theme.palette.grey[800]} />
        <Box height={"100%"} flexGrow={1} sx={{backgroundColor: theme.palette.grey[800]}} textAlign={center ? "center" : undefined} fontSize={18} color={theme.palette.primary.contrastText}>{children}</Box>
        <RightBunt fill={theme.palette.grey[800]} />
    </Box>
}

export default HeadingBar;